module.exports = __webpack_public_path__ + "img/instagram_blue.10dc3b6c.svg";